<p-toast></p-toast>
<div *ngIf="producto">
    <section class="card">
        <h2 style="text-align: center;">Producto</h2>
        <div class="formgrid grid">
            <div class="field col-12 md:col-4">
                <label>Codigo </label>
                <article
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    {{producto.codigo | uppercase}}</article>
            </div>
            <div class="field col-12 md:col-4">
                <label>Producto </label>
                <article
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    {{producto.nomProducto| uppercase}}</article>
            </div>
            <div class="field col-12 md:col-4">
                <label>Caducidad </label>
                <article
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    {{producto.caducidad }}</article>
            </div>
            <div class="field col-12 md:col-4">
                <label>Lote </label>
                <article
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    {{producto.lote| uppercase}}</article>
            </div>
            <div class="field col-12 md:col-4">
                <label>Batch</label>
                <article
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    {{producto.noBatch }}</article>
            </div>
            <div class="field col-12 md:col-12">

                <div class="field-radiobutton">
                    <p-inputSwitch inputId="activo" [(ngModel)]="activo" [disabled]="producto.fk_casoClinico!=null"
                        styleClass="surface-overlay" (onChange)="activardesactivar($event)"></p-inputSwitch>
                    <label for="activo">{{ activo ? 'Activo' : 'Inactivo'}}</label>
                </div>



                <div *ngIf="producto.motivo" class="field col-12 md:col-12">
                    <label>Motivo</label>
                    <p>{{producto.motivo ? producto.motivo : ''}}</p>
                </div>


            </div>
            <div *ngIf="producto.fk_casoClinico" class="field col-12 md:col-12">
                <label>Asignado a</label>
                <article
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                    {{producto.casoclinico.nomHospital }}</article>
            </div>

        </div>
    </section>
</div>

<!-- Modal para motivo al desactivar -->
<p-dialog header="Confirmar desactivación" [(visible)]="showConfirmDialog" [modal]="true" [closable]="false"
    [style]="{width: '480px'}">
    <div class="p-fluid">
        <label for="motivo">Motivo (máx {{motivoMaxLength}} caracteres)</label>
        <textarea id="motivo" rows="5" [(ngModel)]="motivo" [attr.maxlength]="motivoMaxLength"
            class="p-inputtextarea p-component w-full"></textarea>
        <div class="text-right" style="margin-top: .5rem;">
            <small>{{ (motivo ? motivo.length: 0) || 0}} / {{motivoMaxLength}}</small>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Cancelar" class="p-button-text" (click)="cancelDesactivar()"></button>
        <button pButton type="button" label="Confirmar" (click)="confirmDesactivar()"></button>
    </ng-template>
</p-dialog>